<script>
import appConfig from '@src/app.config'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div>
    <div id="app">
      <!--
      Even when routes use the same component, treat them
      as distinct and create the component again.
      -->
      <RouterView :key="$route.fullPath" />
    </div>
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
@import '~nprogress/nprogress.css';

// Design variables and utilities from src/design.
@import '@design';

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  position: relative;
  min-height: 100vh;
  margin: 0;
  background: $color-body-bg;
}
#app {
  @extend %typography-small;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

h1 {
  @extend %typography-xxlarge;
}

h2 {
  @extend %typography-xlarge;
}

h3 {
  @extend %typography-large;
}

h4 {
  @extend %typography-medium;
}

h5,
h6 {
  @extend %typography-small;
}

// ===
// Vendor
// ===

#nprogress .bar {
  background: $color-link-text;
}

h3.title {
  margin-bottom: 0;
}

.zone_card {
  padding-top: 45px;
  padding-right: 0.938em;
  padding-bottom: 45px;
  padding-left: 0.938em;
  margin-bottom: 0.938em;
  color: #fff;
  background-color: #738290;
  border-color: #738290;
  border-style: solid;
  border-width: 2px;
  border-radius: 0.938em;
}

.vertical-center {
  position: absolute;
  top: 50%;
  width: 100%;
  margin: 0;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.event_history {
  padding: 0.938em;
  background-color: #f4f6f7;
  border-color: #000;
  border-style: solid;
  border-width: 2px;
  border-radius: 0.938em;
}

.icon_parent_container {
  padding: inherit;
}

.icon_container {
  padding-right: inherit;
  text-align: right;
}

.btn-danger:hover {
  color: #e61e2e;
}

.zone_card_container {
  margin-bottom: 0.938em;
}

.system_test_container {
  min-height: 3.75em;
}

.btn {
  min-width: 9em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

.history_container {
  padding-bottom: 0.938em;
}

// Circle check animation
$brand-success: #00c9b1;
$loader-size: 3.5em;
$check-height: $loader-size / 2;
$check-width: $check-height / 2;
$check-left: ($loader-size / 9 + $loader-size / 12);
$check-thickness: 0.3125em;
$check-color: $brand-success;

.circle-loader {
  position: relative;
  display: inline-block;
  width: $loader-size;
  height: $loader-size;
  vertical-align: top;
  border: 0.3125em solid rgba(0, 0, 0, 0.2);
  border-left-color: $check-color;
  border-radius: 50%;
  animation: loader-spin 1.2s infinite linear;
}

.load-complete {
  border-color: $check-color;
  transition: border 500ms ease-out;
  -webkit-animation: none;
  animation: none;
}

.checkmark {
  &.draw::after {
    transform: scaleX(-1) rotate(135deg);
    animation-name: checkmark;
    animation-duration: 800ms;
    animation-timing-function: ease;
  }

  &::after {
    position: absolute;
    top: 1.6em;
    left: 0.6em;
    width: $check-width;
    height: $check-height;
    content: '';
    border-top: $check-thickness solid $check-color;
    border-right: $check-thickness solid $check-color;
    opacity: 1;
    transform-origin: left top;
  }
}

@keyframes loader-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes checkmark {
  0% {
    width: 0;
    height: 0;
    opacity: 1;
  }
  20% {
    width: $check-width;
    height: 0;
    opacity: 1;
  }
  40% {
    width: $check-width;
    height: $check-height;
    opacity: 1;
  }
  100% {
    width: $check-width;
    height: $check-height;
    opacity: 1;
  }
}
</style>
